import * as React from "react";
import { Component, MouseEvent } from "react";

import CheckboxField from "components/FormElements/CheckboxField";
import TextField from "components/FormElements/TextField";

import { EditDebtorType } from "./types";

const MAX_PHONE_NUMBERS = 3;

interface PropsType {
  debtor: EditDebtorType;
  onFieldBlur(): void;
  onFieldChange(e: { currentTarget: { name: string; value: string } }): void;
  parent: Component;
}

interface StateType {
  phoneNumberCount: number;
}

export default class ContactInfo extends Component<PropsType, StateType> {
  state: StateType = {
    phoneNumberCount: this.initPhoneNumberCount(),
  };

  initPhoneNumberCount(): number {
    const { debtor } = this.props;

    return ["phone1", "phone2", "phone3"].reduce(
      (acc, key) => (debtor[key] ? acc + 1 : acc),
      0,
    );
  }

  onAddPhoneClick = (e: MouseEvent): void => {
    e.preventDefault();

    this.setState(({ phoneNumberCount }: { phoneNumberCount: number }) => ({
      phoneNumberCount: Math.max(MAX_PHONE_NUMBERS, phoneNumberCount + 1),
    }));
  };

  render(): JSX.Element {
    const { debtor, onFieldBlur, onFieldChange } = this.props;
    const { phoneNumberCount } = this.state;

    return (
      <section className="contact-info">
        <div className="form--fieldset">
          <div className="content">
            <header>
              <div className="badge">
                <i className="fas fa-paper-plane" />
              </div>

              <h3>Contact Information</h3>
            </header>

            <div className="body">
              <TextField
                label="Phone Number"
                name="phone1"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                value={debtor.phone1}
              />

              <TextField
                hidden={phoneNumberCount < 2}
                label="Phone Number 2 (optional)"
                name="phone2"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                value={debtor.phone2 || ""}
              />

              <TextField
                hidden={phoneNumberCount < MAX_PHONE_NUMBERS}
                label="Phone Number 3 (optional)"
                name="phone3"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                value={debtor.phone3 || ""}
              />

              <div className="form--actions">
                <button
                  className="button--blue"
                  hidden={phoneNumberCount === MAX_PHONE_NUMBERS}
                  onClick={this.onAddPhoneClick}
                  type="button"
                >
                  <i className="fas fa-phone" />
                  <span>Add phone</span>
                </button>
              </div>

              <TextField
                autoComplete="username email"
                label="Email"
                name="email"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                placeholder="Email address"
                type="email"
                value={debtor.email}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
